import { render, staticRenderFns } from "./AddWhiteList.vue?vue&type=template&id=7d8a4eb8&scoped=true"
import script from "./AddWhiteList.vue?vue&type=script&lang=js"
export * from "./AddWhiteList.vue?vue&type=script&lang=js"
import style0 from "./AddWhiteList.vue?vue&type=style&index=0&id=7d8a4eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_a684d0c3315dfbe7fcb599809449fa35/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8a4eb8",
  null
  
)

export default component.exports